import { css } from '@emotion/react';
import { Box, Flex, OptimizeImage, Text, desktopFirstMediaQuery } from '@inflearn/ds-react-next';

import { NEXT_PUBLIC_CDN_URL } from '../../../../../appConfig';
import { AI_INTERVIEWS_URL } from '../../../../constants/urls';
import useClientAccountProfileQuery from '../../../../queries/useClientAccountProfileQuery';
import { getB2BRole } from '../../../../utils/getB2BRole';

const TITLE = '실전 면접, 준비 없이 들어가긴 불안하다면';
const DESCRIPTION = '모의면접으로 미리 연습하세요. (1회 무료체험)';
const DEFAULT_IMAGE_URL = `${NEXT_PUBLIC_CDN_URL}/public/static-images/1b4dbd79-25af-4eca-894a-a7973552e52f.png?f=avif`;

export interface MyCoursesAiInterviewBannerProps {
  imageUrl?: string;
}

export const MyCoursesAiInterviewBanner = ({
  imageUrl = DEFAULT_IMAGE_URL,
}: MyCoursesAiInterviewBannerProps) => {
  const { data: user } = useClientAccountProfileQuery();
  const { isB2BUser } = getB2BRole(user ?? null);

  if (!user || isB2BUser) {
    return null;
  }

  return (
    <Box
      component="a"
      href={AI_INTERVIEWS_URL.LANDING({ from: 'my_courses' })}
      css={styleBanner}
      mb={16}
    >
      <Flex align="center" gap={10} css={styleContent}>
        {imageUrl && <OptimizeImage src={imageUrl} alt="" width={48} css={styleImage} />}
        <Flex direction="column" gap={2}>
          <Text css={styleTitle}>{TITLE}</Text>
          <Text css={styleDescription}>{DESCRIPTION}</Text>
        </Flex>
      </Flex>
    </Box>
  );
};

const styleBanner = css({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#F8F9FA',
  border: '1px solid #E9ECEF',
  borderRadius: 8,
  padding: '16px 16px 16px 24px',
  overflow: 'clip',
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
  [desktopFirstMediaQuery.mobile]: {
    padding: '14px 16px',
  },
});

const styleContent = css({
  minWidth: 0,
  flex: 1,
});

const styleImage = css({
  flexShrink: 0,
  [desktopFirstMediaQuery.mobile]: {
    display: 'none',
  },
});

const styleTitle = css({
  fontSize: 16,
  fontWeight: 600,
  color: '#495057',
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 14,
  },
});

const styleDescription = css({
  fontSize: 14,
  fontWeight: 500,
  color: '#ADB5BD',
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 12,
  },
});
